import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHuFlag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_218_3612)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.745963 7.82522C0.26362 9.12525 -0.000427246 10.5313 -0.000427246 11.9991C-0.000427246 13.467 0.26362 14.8731 0.745963 16.173L11.9996 17.2165L23.2532 16.173C23.7355 14.8731 23.9996 13.467 23.9996 11.9991C23.9996 10.5313 23.7355 9.12525 23.2532 7.82522L11.9996 6.78174L0.745963 7.82522Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0004 -0.000976562C6.84086 -0.000976562 2.44229 3.25552 0.746826 7.82513H23.2541C21.5585 3.25552 17.16 -0.000976562 12.0004 -0.000976562Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0004 23.9993C17.16 23.9993 21.5585 20.7428 23.254 16.1732H0.746826C2.44229 20.7428 6.84086 23.9993 12.0004 23.9993Z",
				fill: "#6DA544"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_218_3612",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHuFlag;
